module.exports = __webpack_public_path__ + "img/1728955980625-Screenshot_15-10-2024_93246_.jpeg.b436fc42.webp";